//Analytics used in 3 components in Locator folder:
//src\Feature\Locator\code\Views\DistributorDetail\DistributorDetail.cshtml
//src\Feature\Locator\code\Views\LocatorDetails\KHWSDetail.cshtml
//src\Feature\Locator\code\Views\LocatorDetails\RowDetails.cshtml

//brought from custom component
$(document).ready(function () {
    $feedbackLinks = $('.leave-feedback-link');
    if (!$feedbackLinks.length) return false;
    $feedbackLinks.on('click', function () {
        var locationName = $(this).attr('data-location-name') || '',
            $modalHeading = $('#leaveFeedbackHeader'),
            headingText = $modalHeading.text().replace('{{LocationName}}', locationName);
        $('#leaveFeedbackHeader').text(sanitizeHtmlStrings(headingText));
    });
});

analytics.eventConfig.push({
    "target": ".component.locator-detail",
    "events": [
        // Contact us
        {
            "eventTarget": ".btn-direction-loc a.btn-primary",
            "eventType": "click",
            "tags": {
                "event": "locator",
                "componentId": "lgdsd",
                "componentName": "locator get directions station details",
                "eventType": "get directions outbound click",
                "elementType": "get directions button",
                "elementText": "",
                "destinationUrl": "",
                "searchType": "retailgasstations",
                "titleText": ""
            }
        },
        {
            "eventTarget": ".location-map a.btn-secondary",
            "eventType": "click",
            "tags": {
                "event": "locator",
                "componentId": "ldwb",
                "componentName": "locator details website cta",
                "eventType": "location website outbound click",
                "elementType": "location website button ",
                "elementText": "",
                "destinationUrl": "",
                "searchType": "locator-details",
                "titleText": ""
            }
        },
        {
            "eventTarget": "a[href^='mailto']",
            "eventType": "click",
            "tags": {
                "event": "locator",
                "componentId": "ldcl",
                "componentName": "row locator details contact link",
                "eventType": "location click to email",
                "elementType": "email link",
                "searchType": "locator-details",
                "titleText": ""
            }
        },

        // Contact us tel
        {
            "eventTarget": ".location-info-telephone a[href]", 
            "eventType": "click",
            "tags": {
                "event": "locator",
                "componentId": "ldcl",
                "componentName": "row locator details contact link",
                "eventType": [
                    {
                        "rule": "$(context).attr('href').toLowerCase().startsWith('fax:')",
                        "value": "location click to fax"
                    },
                    {
                        "rule": true,
                        "value": "location click to call"
                    }
                ],
                "elementType": [
                    {
                        "rule": "$(context).attr('href').toLowerCase().startsWith('fax:')",
                        "value": "fax link"
                    },
                    {
                        "rule": true,
                        "value": "phone number link"
                    }
                ],
                "searchType": "locator-details",
                "titleText": ""
            }
        },
        // Get Directions
        {
            "eventTarget": ".location-map .btn-primary a",
            "eventType": "click",
            "tags": {
                "event": "locator",
                "componentId": "ldgd",
                "componentName": "row locator details get directions",
                "eventType": "get directions outbound click",
                "elementType": "get directions button",
                "elementText": "",
                "destinationUrl": "",
                "searchType": "locator-details",
                "titleText": ""
            }
        },
        // Buy online
        {
            "eventTarget": ".location-map .btn-secondary a",
            "eventType": "click",
            "tags": {
                "event": "locator",
                "componentId": "ldwl",
                "componentName": "row locator details website link",
                "eventType": "location website outbound click",
                "elementType": "location website link",
                "elementText": "",
                "destinationUrl": "",
                "searchType": "locator-details",
                "titleText": ""
            }
        },
        {
            "eventTarget": ".location-info-website a",
            "eventType": "click",
            "tags": {
                "event": "locator",
                "componentId": "ldwl",
                "componentName": "row locator details website link",
                "eventType": "location website outbound click",
                "elementType": "location website link",
                "elementText": "",
                "destinationUrl": "",
                "searchType": "locator-details",
                "titleText": "",
                //merged from chemicals
                'event1': '',
                'eventCategory': '',
                'eventAction': 'Visited Distributor Site',
                'eventLabel': "",
                'external_url': "",
                'page_type': 'Distributor Page',
                'page_title': 'Distributor Locator',
                'page_bu': "",
                'environment': "",
                'page_language': "",
                'sitecore_contact_id': "",
                'pardot_cookie_id': "",
                //merged from chemicals
            }
        }
    ]
});